import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { useController } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PatternFormat } from 'react-number-format';

function CustomInputPhoneNumber({
  control,
  name,
  rules,
  defaultValue = '',
  icon = null,
  formLabel = '',
  placeHolder = '',
  typeInput = 'text',
  classNames = {},
  className = { input: 'text-uppercase' },
  disabled = false,
}) {
  // Integracion con React Hook Form
  const {
    field: { onChange, onBlur },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  // Funcion para manejar el cambio del valor
  const handleOnChange = (value) => {
    onChange(value); // Actualiza el valor en React Hook Form
  };

  // Funcion para manejar el focus del input
  // const handleOnBlur = (option) => {};

  return (
    <div className="custom-input position-relative w-100">
      <Card className={`${classNames?.card} ${error ? 'invalid-input-border' : ''}`}>
        <Card.Body className={`${classNames?.cardBody}`}>
          <div className="d-flex">
            {icon && (
              <div className="checking__group-icon pe-2 d-flex align-items-center">
                <FontAwesomeIcon icon={icon} size="2x" className="app-txt-gray" />
              </div>
            )}

            <Form.Group className="flex-fill" controlId={`control-${name}`}>
              {formLabel && (
                <Form.Label
                  className={`mb-0 ${classNames?.label}`}
                >
                  {formLabel}
                </Form.Label>
              )}
              <PatternFormat
                disabled={disabled}
                className={`form-control w-100 border-0 ps-0 shadow-none py-0 ${className.input}`}
                onChange={handleOnChange}
                name={name}
                value={defaultValue} // input value
                format="###############"
                mask=""
                placeholder=""
              />
              {/* <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text> */}
            </Form.Group>
          </div>
        </Card.Body>
      </Card>

      {/* Mostrar mensaje de error */}
      {/* {error && <span className="error-message">{error.message}</span>} */}
    </div>
  );
}

export default CustomInputPhoneNumber;
